import { useCallback, useMemo } from "react";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import { BUTTON_VARIANTS } from "../../../../components/inputs/button-variants";
import { DefaultModalLayout } from "../../../../components/modal/layouts/default-modal-layout";
import amazon_svg_logo from '../../../../images/logos/amazon-mcf-logo.svg';
// import returngo_logo from '../../../../images/logos/returngo-logo.svg';
import returngo_logo from '../../../../images/logos/returngo-with-right-border-logo.svg';
import amazon_mcf_install_stepper from '../../../../images/amazon-mcf-install-step-3.svg';
import AmazonMcfModalStore from "./amazon-mcf-modal-store";
import "./amazon-mcf-modal.scss";
import { Button } from "../../../../components/inputs/button/button";
import AmazonMcfCredentials from "../../../integrations/products-services/components/credentials/amazon-mcf-credentials/amazon-mcf-credentials";
import { observer } from "mobx-react";

interface IProps {
    onClose: (isConnected: boolean) => void;
}

export const AmazonMcfModal: React.FC<IProps> = observer(({ onClose }) => {
    
    const store = useMemo<AmazonMcfModalStore>(() => new AmazonMcfModalStore(onClose), [onClose]);

    const onModalClose = useCallback(async () => {
        if (store.isProcessing) {
            return;
        }
        await onClose(false);
    }, [onClose, store.isProcessing]);

    return (
        <DefaultModalLayout
            onCloseClicked={() => { /** prevent the modal to be closed by X or by click outside */ }}
            isCloseDisabled={true}
        >
            <div className="amazon-mcf-modal-content">
                <div className="modal-header">
                    <img src={returngo_logo} alt="returngo" />
                    <img src={amazon_svg_logo} alt="amazon mcf" />
                </div>
                <p>
                    <FontBody1>Hi,</FontBody1>
                </p>
                <p>
                    <FontBody1>Thank you for installing ReturnGO.</FontBody1>
                </p>
                <p>
                    <FontBody1>We have partnered with Amazon Multi-Channel Fulfillment (MCF) to provide merchants with the most robust returns solution, now powering returns to MCF locations worldwide.
                        Login to your Amazon Seller Central account to view custom plans for ReturnGO and Amazon MCF merchants.</FontBody1>
                </p>
                <p>
                    <FontBody1>Thank you</FontBody1>
                </p>
                
                {!!store.ceredentialStore && 
                    <AmazonMcfCredentials credentialsStore={store.ceredentialStore}  />
                }
                
                <div className="modal-buttons">
                    <Button
                        variant={BUTTON_VARIANTS.Tertiary}
                        text="I Don't have an account"
                        onClick={onModalClose}
                    />
                    <Button
                        hasLoader
                        variant={BUTTON_VARIANTS.Primary}
                        text="Login to your account"
                        onClick={store.register}
                        disabled={store.isLoading}
                        isLoading={store.isLoading || store.isProcessing}
                    />
                </div>
                <img className="installation-stepper-step-3-img" src={amazon_mcf_install_stepper} alt="Login to Amazon mcf" />
            </div>
        </DefaultModalLayout>
    );
});
